import sites from './savanna/sites.module';
import gcus from './savanna/gcus.module';
import trackers from './savanna/trackers.module';
import telemetry from './savanna/telemetry.module';
import subarrays from './savanna/subarrays.module';

export default {
  namespaced: true,
  state: {},
  modules: {
    sites,
    gcus,
    trackers,
    telemetry,
    subarrays
  },
};
